import { render, staticRenderFns } from "./fine.vue?vue&type=template&id=4c952c70&scoped=true"
import script from "./fine.vue?vue&type=script&lang=js"
export * from "./fine.vue?vue&type=script&lang=js"
import style0 from "./fine.vue?vue&type=style&index=0&id=4c952c70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c952c70",
  null
  
)

export default component.exports